import { defineMessages } from 'react-intl';

export default defineMessages({
	statusDescription: {
		id: 'components.walletPayment.statusTransaction.unSuccess.statusDescription',
		defaultMessage: 'پرداخت مشتری ناموفق بود!',
	},
	description: {
		id: 'components.walletPayment.statusTransaction.unSuccess.description',
		defaultMessage: 'از مشتری بخواهید فرآیند پرداخت را دوباره انجام دهد.',
	},
	backButton: {
		id: 'components.walletPayment.statusTransaction.unSuccess.backButton',
		defaultMessage: 'برگشت به خانه',
	},
	tryAgainButton: {
		id: 'components.walletPayment.statusTransaction.unSuccess.tryAgainButton',
		defaultMessage: 'اسکن بارکد',
	},
});
